"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var DropItem_1 = __importDefault(require("../../DropItem/DropItem"));
var ProfileIcon_1 = __importDefault(require("../../ProfileIcon/ProfileIcon"));
var ProfileDropItem = /** @class */ (function (_super) {
    __extends(ProfileDropItem, _super);
    function ProfileDropItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderName = function () {
            var _a = _this.props, firstName = _a.firstName, lastName = _a.lastName, userRole = _a.userRole;
            var lname = lastName ? lastName : '';
            return (React.createElement("div", { className: "name-info" },
                React.createElement("div", { className: "name" },
                    firstName,
                    " ",
                    lname),
                userRole && React.createElement("div", { className: "userRole" }, userRole)));
        };
        return _this;
    }
    ProfileDropItem.prototype.render = function () {
        var _a = this.props, firstName = _a.firstName, lastName = _a.lastName, imageUrl = _a.imageUrl;
        return (React.createElement(DropItem_1.default, { isBadged: false, className: "user-profile-drop", disabled: true },
            React.createElement("div", null,
                React.createElement(ProfileIcon_1.default, { firstName: firstName, lastName: lastName, imageUrl: imageUrl })),
            this.renderName()));
    };
    return ProfileDropItem;
}(react_1.Component));
exports.default = ProfileDropItem;
